import {Middleware} from '~/node_modules/@nuxt/types'
import { Core } from "~/core/Core"
import { TimeHelper } from "~/utils/TimeHelper";

const auth: Middleware = async (ctx) => {

  if (Core.config.ENABLED_SKIP_PAGE_PLATFORM_SELECTION) {
    let adToken = ctx.route.query.token;
    let appID = ctx.route.query.application_id;
    let passParam = {}

    if (adToken) {
      passParam = {...passParam, token: adToken}
    }
    if (appID) {
      passParam = {...passParam, application_id: appID}
    }

    if (ctx.route.path == '/') {
      return ctx.redirect(`/marketing`, passParam)
    }
  }

  if (ctx.app.$auth.isNotAuth && !ctx.app.$cookies.get('me')?.token) {

    if (ctx.app.$auth.enabledFeatureLoginADToken) {
      let adToken = ctx.route.query.token;
      let appID = ctx.route.query.application_id;
      let passParam = {}
      if (adToken) {
        passParam = {...passParam, token: adToken}
      }
      if (appID) {
        passParam = {...passParam, application_id: appID}
      }

      if (Core.config.ENABLED_SKIP_PAGE_PLATFORM_SELECTION) {
        if (ctx.route.path == '/') {
          return ctx.redirect(`/marketing`, passParam)
        }
      }
      return

    }

    return ctx.redirect(`/login`, {
      ...(ctx.route.path && ctx.route.path !== '/' && {redirect: ctx.route.path})
    })
  }

  const mustChangePassword = ctx.app.$auth.me?.must_change_password
  if (
    mustChangePassword &&
    ctx.route.path !== '/force-change-password'
  ) {
    return ctx.redirect(`/force-change-password`, {
      ...(ctx.route.path && ctx.route.path !== '/' && {redirect: ctx.route.path})
    })
  }
}

export default auth
